import { render } from "./UpdateRecordPopUp.vue?vue&type=template&id=42552d35&scoped=true"
import script from "./UpdateRecordPopUp.vue?vue&type=script&lang=js"
export * from "./UpdateRecordPopUp.vue?vue&type=script&lang=js"

import "./UpdateRecordPopUp.vue?vue&type=style&index=0&id=42552d35&scoped=true&lang=css"

import exportComponent from "/var/www/www.newtoncommoditiesscripts.com/vue-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42552d35"]])

export default __exports__